import SideMenu, { SideMenuLink } from '@amzn/meridian/side-menu';

import Button from '@amzn/meridian/button';
import Divider from '@amzn/meridian/divider';
import Heading from '@amzn/meridian/heading';
import Input from '@amzn/meridian/input';
import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import modules from '../../modules';
import { useHistory } from 'react-router-dom';

const Sidebar = ({ open, toggleOpen, accessGroups, currentModule, setCurrentModule, areAnyTenantsAvailable }) => {
  const history = useHistory();

  return (
    <SideMenu open={open} titleComponent={Heading}>
      <Heading level={4} tabIndex="-1">
        Customer service
      </Heading>
      {modules
        .filter(module => !module.accessGroup || accessGroups.includes(module.accessGroup))
        .map(module => (
          <SideMenuLink
            key={module.name}
            selected={module.name === currentModule}
            href={module.routeProps.path}
            disabled={!module.active || !areAnyTenantsAvailable}
            onClick={() => {
              toggleOpen();
              if (currentModule !== module.name) {
                setCurrentModule(module.name);
                history.push(module.routeProps.path);
              }
            }}
          >
            <i className={'d-inline ' + module.iconClassName}>{'    '}</i>
            {module.label}
          </SideMenuLink>
        ))}
      <Row spacingInset="xsmall">
        <Input disabled type="search" color="secondary" size="small" placeholder="Project, TM, TB, User Profile" />
      </Row>
      <Row spacingInset="xsmall" spacing="xsmall">
        <Button disabled size="small">
          Create new
        </Button>
        <Text type="b200" color="secondary">
          <i className="icon-triangle-right"></i>Recent Items
        </Text>
      </Row>
      <Divider spacingBefore="small" spacingAfter="small" />
      <Row spacingInset="xsmall">
        <Text type="b200" color="secondary">
          <i className="icon-books"></i> User Manual
        </Text>
      </Row>
      <Row spacingInset="xsmall">
        <Text type="b200" color="secondary">
          <i className="icon-bin2"></i> Recycle Bin
        </Text>
      </Row>
    </SideMenu>
  );
};

export default Sidebar;
